/**
 * @readonly
 * @enum {string}
 */
export const Engine = {
    BROWSER: 'browser',
    CORDOVA: 'cordova',
};

/**
 * Determines if the current document has been loaded via a protocol
 * that indicates it is being loaded through cordova.
 * @return {Boolean}
 */
function isCordovaBasedProtocol() {
    return !([
        // List of protocols that will NEVER serve a cordova app
        'http:',
        'https:',
    ].includes(document.location.protocol));
}

export function isIonicWebView(){
    return document.location.protocol.includes('ionic');
}

/**
 * Returns the engine that is currently running this app.
 * @return {Engine}
 */
export function determineEngine() {
    // window.cordova will not exist if cordova.js has not been loaded
    // but we can infer if we are running on cordova based on the protocol
    if (!!window.cordova || isCordovaBasedProtocol())
        return Engine.CORDOVA;
    else
        return Engine.BROWSER;
}

/**
 * Determines if the current document has been loaded inside a iframe 'live-preview'
 * TODO: Maybe this is a `new` engine: Engine.IFRAME
 * @returns {Boolean}
 */
export function isIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/shared/engine-dynamic/engine.js